import { QueryClient, useQuery } from '@tanstack/react-query';
import { ContestApi } from 'api/ApiHelper';
import { contestsQueryKey } from 'queries/contests/queryKey';

export const useGetContestFancySharesQuery = (contestId: number) =>
  useQuery({
    queryKey: contestsQueryKey.contestsFancyShares(contestId),
    queryFn: () => ContestApi.getContestFancyShares(contestId),
    enabled: contestId > 0,
    refetchInterval: 60 * 1000,
  });

export const prefetchContestFancySharesQuery = (queryClient: QueryClient, contestId: number) =>
  queryClient.prefetchQuery({
    queryKey: contestsQueryKey.contestsFancyShares(contestId),
    queryFn: () => ContestApi.getContestFancyShares(contestId),
    staleTime: 1000 * 60 * 5,
  });
